import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes,
  provideRouter,
  withComponentInputBinding,
} from '@angular/router';
import { AuthGuard, RoleGuard } from '@shared/guards';

import { UserCompany, UserProfiles } from '@shared/models';
import { DefaultLayoutComponent } from './containers';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: $localize`Home`,
    },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'clients',
        loadChildren: () => import('./modules/client/client.module'),
        data: {
          allowedRoles: [UserProfiles.SUPERADMIN],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: 'institution',
        loadChildren: () => import('./modules/institution/institution.module'),
        data: {
          allowedRoles: [UserProfiles.SUPERADMIN],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: 'distributor',
        loadChildren: () => import('./modules/distributor/distributor.module'),
        data: {
          allowedRoles: [UserProfiles.SUPERADMIN],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: 'doctor',
        loadChildren: () => import('./modules/doctor/doctor.module'),
        data: {
          allowedRoles: [UserProfiles.SUPERADMIN],
        },
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: 'erkom',
        loadChildren: () => import('./modules/erkom/erkom.module'),
        data: {
          allowedRoles: [
            UserProfiles.MEDICO,
            UserProfiles.ADMIN,
            UserProfiles.SUPERADMIN,
          ],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: 'fmf',
        loadChildren: () => import('./modules/fmf/fmf.module'),
        data: {
          allowedRoles: [
            UserProfiles.MEDICO,
            UserProfiles.ADMIN,
            UserProfiles.SUPERADMIN,
          ],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: 'patient',
        loadChildren: () => import('./modules/patient/patient.module'),
        data: {
          allowedRoles: [
            UserProfiles.MEDICO,
            UserProfiles.ADMIN,
            UserProfiles.SUPERADMIN,
          ],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: 'users',
        loadChildren: () => import('./modules/user/user.module'),
        data: {
          allowedRoles: [UserProfiles.SUPERADMIN, UserProfiles.ADMIN],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: 'profile',
        loadComponent: () => import('./modules/profile/profile.component'),
        data: {
          allowedRoles: [UserProfiles.MEDICO],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: 'manufacturer',
        loadChildren: () =>
          import('./modules/manufacturer/manufacturer.module'),
        data: {
          allowedRoles: [UserProfiles.SUPERADMIN],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: 'regions',
        loadChildren: () => import('./modules/regions/regions.module'),
        data: {
          allowedRoles: [UserProfiles.SUPERADMIN],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: 'studies',
        loadChildren: () =>
          import('./modules/studies/studies.module').then(
            (m) => m.StudiesModule
          ),
        data: {
          allowedRoles: [UserProfiles.SUPERADMIN, UserProfiles.ADMIN],
          allowedCompany: [UserCompany.SCANMED],
        },
        canActivate: [AuthGuard, RoleGuard],
      },
    ],
  },
  {
    path: 'viewer',
    loadChildren: () => import('./modules/viewer/viewer.module'),
    data: {
      allowedRoles: [UserProfiles.MEDICO, UserProfiles.SUPERADMIN, UserProfiles.ADMIN],
    },
    canActivate: [AuthGuard, RoleGuard],
  },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
      // relativeLinkResolution: 'legacy'
    }),
  ],
  exports: [RouterModule],
  providers: [provideRouter(routes, withComponentInputBinding())],
})
export class AppRoutingModule { }
